import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Icons } from "./../Icons";
import moment from "moment";
import ModalTrazabilidad from "./../ModalTrazabilidad";
import { useNavigate } from "react-router-dom";
import { puedeBaja } from "../../utils/permisosFlujo";
import { FlujoMemorias } from "../../services/PpafeServices";
import { FlujoMemoriasAF } from "../../services/PpafeservicesAF";
import axios from "axios";
import Swal from "sweetalert2";
import { ArrowCircleDown, ArrowCircleUp } from "@mui/icons-material";

interface ColumnsProps {
  handleVerClick: (uuid: string, link: string) => void;
  urlOrigen?: string;
  navigate: (path: string) => void; // Agregar navigate como parámetro
}

const getColumnsMemoriasAF = ({
  handleVerClick,
  urlOrigen,
  navigate, // Recibir navigate como argumento
}: ColumnsProps): GridColDef[] => {

  const BASEURL = `${process.env.REACT_APP_APPLICATION_ENDPOINT}/aportaciones/federales/memorias/orden/`;


  const ordenar = async (id: string, accion: "SUBE" | "BAJA") => {
    try {
      const response = await axios.put(
        `${BASEURL}${id}/${accion}`,
        {},
        {
          headers: {
            Authorization: localStorage.getItem("jwtToken") || "",
          },
        }
      );

      if (response.status === 200) {
        window.location.reload();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error al cambiar el orden",
          text:
            response.data.message ||
            "Ocurrió un problema al guardar los cambios. Intenta nuevamente.",
        });
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Error en la solicitud",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Ocurrió un error inesperado. Intenta nuevamente.",
      });
    }
  };

  const flujoDetalle = (accion: "avanzar" | "devolver", id: string) => {
    const tipo = "aportaciones";
    const origen = "federales";

    FlujoMemoriasAF(tipo, origen, () => { }, () => { }, () => { }, "ELIMINAR", id || "", accion);
  };

  const openSolicitud = (id: string) => {
    const url = `/admin/aportaciones/federales/verificacionmemoriasaf/${id}`;
    navigate(url);
  };
  return [
    {
      field: "acciones",
      headerName: "Acciones",
      headerAlign: "left",
      width: 300,
      sortable: false,
      hideable: false,
      renderCell: (cellValues: any) => {
        const isDisabled = cellValues.row.estatus?.toLowerCase() === "oculto";
        return (
          <Box display="flex" alignItems="center">
            {
              puedeBaja() &&

              <Box sx={{ paddingLeft: "5px" }} ml={2}>
                <Tooltip title="Baja" placement="top">
                  <IconButton onClick={() => flujoDetalle("avanzar", cellValues.row.id)} color="primary" disabled={isDisabled}>
                    {Icons("DeleteForever")}
                  </IconButton>

                </Tooltip>
              </Box>
            }
            <Box sx={{ paddingLeft: "5px" }} ml={2}>
              <Tooltip title="Abrir Registro" placement="top">
                <IconButton
                  onClick={() => openSolicitud(cellValues.row.id)}
                  color="primary">
                  {Icons("Description")}
                </IconButton>
              </Tooltip>
            </Box>
            <Box sx={{ paddingLeft: "5px" }} ml={1}>
              <ModalTrazabilidad uuid={cellValues.row.id} urlOrigen={urlOrigen} />
            </Box>
            <Box sx={{ paddingLeft: "5px" }} ml={2}>
              <Tooltip title="Semaforización" placement="bottom">
                {/* Ejemplo de otro icono con onClick */}
                <IconButton color="primary">
                  {Icons("CheckCircle")}
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "orden",
      headerName: "Orden",
      width: 200,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        return (
          <Box display="flex" alignItems="center">
            {/* Valor visible con tooltip */}
            <Box sx={{ paddingRight: "8px" }}>
              <Tooltip title={cellValues.value}>
                <Typography variant="body2" noWrap>
                  {cellValues.value}
                </Typography>
              </Tooltip>
            </Box>

            {/* Botón subir */}
            <Box sx={{ paddingLeft: "5px" }} ml={1}>
              <Tooltip title="Mover arriba" placement="top">
                <IconButton size="small" color="primary" onClick={() => ordenar(cellValues.row.id, "SUBE")}>
                  <ArrowCircleUp />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Botón bajar */}
            <Box sx={{ paddingLeft: "5px" }} ml={1}>
              <Tooltip title="Mover abajo" placement="top">
                <IconButton size="small" color="primary" onClick={() => ordenar(cellValues.row.id, "BAJA")}>
                  <ArrowCircleDown />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "titulo",
      headerName: "Titulo del Documento",
      width: 800,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.value}>
            {cellValues.value}
          </Tooltip>
        );
      },
    },
    {
      field: "fecha",
      headerName: "Fecha",
      width: 100,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        const fechaFormateada = moment.utc(cellValues.value).format("DD/MM/YYYY");
        return (
          <Tooltip title={fechaFormateada}>
            <span>{fechaFormateada}</span>
          </Tooltip>
        );
      }
    },
    {
      field: "estatus",
      headerName: "Estatus",
      width: 100,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        const estatus = cellValues.row.estatus?.toLowerCase() === "oculto" ? "BAJA" : cellValues.row.estatus;
        return (
          <Tooltip title={estatus}>
            <span>{estatus}</span>
          </Tooltip>
        );
      }
    },

  ];
};

export default getColumnsMemoriasAF;
